import React, { useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import UserTabs from '../../components/UserTabs'
import { useDispatch, useSelector } from 'react-redux'
import { Box, useMediaQuery } from '@mui/material'
import CreateOrderForm from '../../components/CreateOrderForm'
import CreateOrderButton from '../../components/CreateOrderButton'
import FilterByTag from '../../components/FilterByTag'
import { updateFormActions } from '../../redux/store'

export default function UserTask() {
	const dispatch = useDispatch()
	const { showUpdateForm } = useSelector((state) => state.updateForm)
	const { showFilterByTag } = useSelector((state) => state.filterByTag)
	const mediaMd = useMediaQuery('(min-width:768px)')
	const { currentUser } = useSelector((state) => state.currentUser)
	const [showForm, setShowForm] = useState(false)

	//------SHOW FORM------
	const handleShowForm = (boolean) => {
		setShowForm(boolean)
	}

	const handleShowUpdateForm = (boolean) => {
		dispatch(updateFormActions.hideUpdateForm())
		dispatch(updateFormActions.editOrder(null))
	}

	return (
		<UserLayout>
			<UserTabs />
			<Box
				position='fixed'
				sx={{
					bottom: 0,
					left: mediaMd ? 300 : 0,
					right: 0,
				}}>
				{showFilterByTag && currentUser.permission?.includes('filterByTag') && <FilterByTag />}
				{showUpdateForm && currentUser.permission?.includes('updateOrder') && (
					<CreateOrderForm handleShowForm={handleShowUpdateForm} open={showUpdateForm} />
				)}
				{showForm && !showUpdateForm && !showFilterByTag && currentUser.permission?.includes('createOrder') && (
					<CreateOrderForm handleShowForm={handleShowForm} open={showForm} />
				)}
				{!showForm && !showUpdateForm && !showFilterByTag && currentUser.permission?.includes('createOrder') && (
					<CreateOrderButton setShowForm={setShowForm} />
				)}
			</Box>
		</UserLayout>
	)
}
